package com.fireavert.yardi.common_data.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class YardiCommonDataClientResidentResponse(
    val residents: List<YardiProperty>
)